import React from 'react';

const ProcessSection = () => {
  return (
    <section style={{ background: '#f5efe7', height: 'auto' }}>
      <div className="container" style={{ padding: '30px' }}>
        <h2>Our A-to-Z In-House Process</h2>
        <p className="text-center1">
          We proudly follow a complete in-house process to ensure freshness,
          purity, and consistency in every bite.
        </p>

        <div className="grids">
          <div className="cards">✔ Premium Ingredient Sourcing</div>
          <div className="cards">✔ Handcrafted Production</div>
          <div className="cards">✔ Quality & Hygiene Control</div>
          <div className="cards">✔ Fresh Packaging</div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
